import { router, usePage } from "@inertiajs/react"
import { ChevronDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { leaguePath } from "@/routes"
import type { League } from "@/types"

const CURRENT_LEAGUE_KEY = "current-league-id"

interface InlineLeagueSwitcherProps {
  currentLeagueName: string
}

export function InlineLeagueSwitcher({
  currentLeagueName,
}: InlineLeagueSwitcherProps) {
  const { leagues } = usePage().props

  const handleSelect = (league: League) => {
    localStorage.setItem(CURRENT_LEAGUE_KEY, league.id)
    router.visit(leaguePath(league.id))
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="text-foreground/80 hover:text-foreground inline-flex cursor-pointer items-center gap-1 text-sm font-medium transition-colors">
        <span className="max-w-[200px] truncate">{currentLeagueName}</span>
        <ChevronDown className="h-3.5 w-3.5 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        {leagues.map((league) => (
          <DropdownMenuItem
            key={league.id}
            onClick={() => handleSelect(league)}
            className="cursor-pointer"
          >
            <span className="truncate">{league.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
